import React from "react";

import { Box, Flex, Divider } from "flicket-ui";
import { EventQuery } from "~graphql/sdk";
import Image from "~components/common/Image";
import EventInformation from "../events.EventInformation";

type MobileDetailProps = {
  event: EventQuery["event"];
};

export const Mobile = ({ event }: MobileDetailProps) => {
  const { title, logo } = event;

  return (
    <Flex flexDir="column" px={2} pb={5} overflowY="auto" flex="1">
      <Box flex="1" mt={logo ? 0 : 4}>
        {logo && (
          <>
            <Image alt={title} mt={4} image={logo} />
            <Divider my={4} />
          </>
        )}
        <EventInformation event={event} />
      </Box>
    </Flex>
  );
};
